// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__7_QqQ","colMin":"styles_colMin__1ZPTL","colCheckbox":"styles_colCheckbox__1xtSC"};